import { useRouter } from 'node_modules/next/router';
import { useEffect, useState } from 'react';
import { useStoreSubscriptionConfigs } from 'src/hooks/useStoreSubscriptionConfigs';
import { useSSRSelector } from 'src/redux';

// Summary: For developers: Access all the functionalities of admin builder, with non-admin token
// These will only work when loginViaAdminCreds="true" i.e. new builder is opened
// These are helpful to you as a developer as for merchant's with new subscription will now be able to access the new builder
// So, when using simple merchant token, only limited widget will be visible, so as a developer you can add accessLevel=alphs in query
// to access all the functionalities of the builder, without need of admin POC token
export const BUILDER_ACCESS_LEVEL = {
  ADMIN: 'alpha', // complete access to new builder
  MERCHANT: 'tradesman', // merchant access to new builder
  SALES: 'peddler', // sales-poc access
};

export function useGetBuilderAccessValues() {
  const { query } = useRouter();
  const { storeData } = useSSRSelector((state) => ({
    storeData: state.storeReducer.store,
  }));
  const statuses = useStoreSubscriptionConfigs();
  const [builderAccess, setBuilderAccess] = useState(calcBuilderAccess());

  useEffect(() => {
    setBuilderAccess(calcBuilderAccess());
  }, [query, statuses?.subscriptionStatus?.isOldSubscriptionActive]);

  function calcBuilderAccess() {
    const hasInternalAdminAccess = storeData?.internal_admin_access === 1;
    // query.loginViaAdminCreds signifies -> that new builder has to open or not
    const hasAdminAccess = query.loginViaAdminCreds === 'true' || hasInternalAdminAccess;
    return {
      // Merchant level admin
      hasAdminAccess,
      // Company level admin to directly access merchant's store
      hasInternalAdminAccess,
      hasMerchantAdminAccess:
        !statuses?.subscriptionStatus?.isOldSubscriptionActive &&
        query.accessLevel !== BUILDER_ACCESS_LEVEL.ADMIN &&
        ((hasAdminAccess && query.accessLevel === BUILDER_ACCESS_LEVEL.MERCHANT) ||
          (hasAdminAccess && !hasInternalAdminAccess)),
      hasInternalAdminAccessExpired: false,
    };
  }

  return builderAccess;
}
